import { Articolo } from "./Articolo";
import MenuSezione from "./MenuSezione";
import { MenuSezioneArticoloDeliverect } from "./MenuSezioneArticoloDeliverect";

export default class MenuSezioneArticolo {
    id!: number;
    deliverectId?: string;
    mostraMenu!: boolean;
    bloccato!: boolean;
    articoloId?: number;
    articolo!: Articolo;
    menuSezioneId?: number;
    menuSezione!: MenuSezione;
    menuSezioneArticoloDeliverect?: MenuSezioneArticoloDeliverect;
    ordinamento!: number;
    hasPass!: boolean;

    static fromJson(json: any) {
        let result = new MenuSezioneArticolo();
        result.id = json.id;
        result.deliverectId = json.deliverectId;
        result.mostraMenu = json.mostraMenu;
        result.bloccato = json.bloccato;
        result.articoloId = json.articoloId;
        result.menuSezioneId = json.menuSezioneId;
        result.hasPass = json.hasPass;

        if (json.menuSezione) {
            result.menuSezione = MenuSezione.fromJson(json.menuSezione);
        }

        if (json.articolo) {
            result.articolo = Articolo.fromJson(json.articolo);
        }

        return result;
    }
}